module.exports = __webpack_public_path__ + "img/1727922233986-5983ff4a-af97-4fa9-948e-9ac19083aa91.jpeg.ebed39f8.webp";